import { render, staticRenderFns } from "./ValidateCorrespondence.vue?vue&type=template&id=7bcd294a&scoped=true&"
import script from "./ValidateCorrespondence.vue?vue&type=script&lang=ts&"
export * from "./ValidateCorrespondence.vue?vue&type=script&lang=ts&"
import style0 from "./ValidateCorrespondence.vue?vue&type=style&index=0&id=7bcd294a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcd294a",
  null
  
)

export default component.exports